import apiClient from "../../../api-client";
import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useForumTablesQuery = getWrappedUseQuery(KEYS.GET_FORUM_TABLES, apiClient.ForumTables.getAll);

export const useForumTablesPaginatedQuery = getWrappedUseQuery(
  KEYS.GET_FORUM_TABLES_PAGINATED,
  apiClient.ForumTables.getAllPaginated,
);
